import React, { useState } from "react";
import Slider from "react-slick";

import "../css/Gallery.css";
import photo1 from "../images/1.jpg";
import photo2 from "../images/2.jpg";
import photo3 from "../images/3.jpg";
import photo4 from "../images/4.jpg";
import photo5 from "../images/5.jpg";
import photo6 from "../images/6.jpg";
import photo7 from "../images/7.jpg";
import photo8 from "../images/8.jpg";
import photo9 from "../images/9.jpg";
import photo10 from "../images/10.jpg";
import photo11 from "../images/11.jpg";
import photo12 from "../images/12.jpg";
import photo13 from "../images/13.jpg";
import photo14 from "../images/14.jpg";
import photo15 from "../images/15.jpg";
import photo16 from "../images/16.jpg";
import photo17 from "../images/17.jpg";
import photo18 from "../images/18.jpg";
import photo19 from "../images/19.jpg";
import photo20 from "../images/20.jpg";
import photo21 from "../images/21.jpg";
import photo22 from "../images/22.jpg";
import photo23 from "../images/23.jpg";
import photo24 from "../images/24.jpg";
import photo25 from "../images/25.jpg";
import photo26 from "../images/26.jpg";
import photo27 from "../images/27.jpg";
import photo28 from "../images/28.jpg";
import photo29 from "../images/29.jpg";
import photo30 from "../images/30.jpg";
import photo31 from "../images/31.jpg";
import photo32 from "../images/32.jpg";
import photo33 from "../images/33.jpg";
import photo34 from "../images/34.jpg";
import photo35 from "../images/35.jpg";
import photo36 from "../images/36.jpg";
import photo37 from "../images/37.jpg";
import photo38 from "../images/38.jpg";
import photo39 from "../images/39.jpg";
import photo40 from "../images/40.jpg";

const photos = [
  { src: photo1, alt: "Munich 1" },
  { src: photo2, alt: "Munich 2" },
  { src: photo3, alt: "Munich 3" },
  { src: photo4, alt: "Munich 4" },
  { src: photo5, alt: "Munich 5" },
  { src: photo6, alt: "Munich 6" },
  { src: photo7, alt: "Munich 7" },
  { src: photo8, alt: "Munich 8" },
  { src: photo9, alt: "Munich 9" },
  { src: photo10, alt: "Munich 10" },
  { src: photo11, alt: "Munich 11" },
  { src: photo12, alt: "Munich 12" },
  { src: photo13, alt: "Munich 13" },
  { src: photo14, alt: "Munich 14" },
  { src: photo15, alt: "Munich 15" },
  { src: photo16, alt: "Munich 16" },
  { src: photo17, alt: "Munich 17" },
  { src: photo18, alt: "Munich 18" },
  { src: photo19, alt: "Munich 19" },
  { src: photo20, alt: "Munich 20" },
  { src: photo21, alt: "Munich 21" },
  { src: photo22, alt: "Munich 22" },
  { src: photo23, alt: "Munich 23" },
  { src: photo24, alt: "Munich 24" },
  { src: photo25, alt: "Munich 25" },
  { src: photo26, alt: "Munich 26" },
  { src: photo27, alt: "Munich 27" },
  { src: photo28, alt: "Munich 28" },
  { src: photo29, alt: "Munich 29" },
  { src: photo30, alt: "Munich 30" },
  { src: photo31, alt: "Munich 31" },
  { src: photo32, alt: "Munich 32" },
  { src: photo33, alt: "Munich 33" },
  { src: photo34, alt: "Munich 34" },
  { src: photo35, alt: "Munich 35" },
  { src: photo36, alt: "Munich 36" },
  { src: photo37, alt: "Munich 37" },
  { src: photo38, alt: "Munich 38" },
  { src: photo39, alt: "Munich 39" },
  { src: photo40, alt: "Munich 40" },
];

const Gallery: React.FC = () => {
  const [showCarousel, setShowCarousel] = useState(true);

  const settings = {
    // dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    adaptiveHeight: false,
    cssEase: "ease-in-out",
    // fade: true,
  };

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "2rem 1rem" }}>
      <h2 style={{ marginBottom: "1rem", textAlign: "center" }}>
        Since moving to Munich
      </h2>

      <div style={{ textAlign: "center", marginBottom: "2rem" }}>
        <button
          onClick={() => setShowCarousel(!showCarousel)}
          style={{
            padding: "0.6rem 1.2rem",
            fontSize: "1rem",
            borderRadius: "999px",
            border: "none",
            background: "linear-gradient(135deg, #0070f3, #00bcd4)",
            color: "white",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            transition: "transform 0.2s ease, box-shadow 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "scale(1.05)";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(0,0,0,0.25)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "scale(1)";
            e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
          }}
        >
          {showCarousel ? "Switch to Grid View" : "Switch to Slideshow"}
        </button>
      </div>

      {showCarousel ? (
        <Slider {...settings}>
          {photos.map((photo, index) => (
            <div key={index}>
              <img
                src={photo.src}
                alt={photo.alt}
                style={{
                  width: "100%",
                  height: "500px",
                  objectFit: "cover",
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                }}
              />
            </div>
          ))}
        </Slider>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
            gap: "1rem",
          }}
        >
          {photos.map((photo, index) => (
            <img
              key={index}
              src={photo.src}
              alt={photo.alt}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "12px",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Gallery;
